import React from 'react';
import { ICONS as SVG } from '@sfstudios/shapeshifter';
import { ElementRef, useEffect, useRef } from 'react';
import styled from 'styled-components';

export type IconName = keyof typeof SVG;

const IconWrapper = styled.span<{
  $height?: string | number;
  $width?: string | number;
  $fill?: string;
  $svgStyle?: object;
}>`
  svg {
    height: ${({ $height }) => $height && `${$height}px`};
    width: ${({ $width }) => $width && `${$width}px`};
    fill: ${({ $fill }) => $fill};
    ${({ $svgStyle }) => ({ ...$svgStyle })};
  }
`;

export const Icon = ({
  name,
  height,
  width,
  fill,
  style,
  ...rest
}: {
  name: IconName;
  height?: string | number;
  width?: string | number;
  fill?: string;
  style?: object;
  className?: string;
  onClick?: () => void;
}) => {
  const wrapperRef = useRef<ElementRef<'span'>>(null);

  useEffect(() => {
    const className = rest?.className;
    if (typeof className !== 'string') return;
    if (!wrapperRef.current) return;

    // Find svg element in the wrapper
    const svg = wrapperRef.current.querySelector('svg');
    if (!svg) return;

    // Add multi classnames to svg element from string
    svg.classList.add(...className.split(' '));
  }, [rest?.className]);

  return (
    <IconWrapper
      ref={wrapperRef as any}
      $height={height}
      $width={width}
      $fill={fill}
      dangerouslySetInnerHTML={{ __html: SVG[name] ?? '' }}
      $svgStyle={style}
      {...rest}
    />
  );
};
